import React from 'react';

import { Box, ButtonFilled, Flex, Text, Image } from 'Components/Base';

const AppIncompletedContent = () => {
  const handleBackToHome = () => {
    // Go back to app home page
    window.flutter_inappwebview?.callHandler('backToHome');
  };

  return (
    <Flex
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      style={{ height: '100vh' }}
    >
      <Image src="/assets/images/app/incompleted_content.png" height={'128px'} />
      <Text textStyle={'heading4'} mt={3}>
        นำเข้าเนื้อหาไม่สมบูรณ์
      </Text>
      <Text textStyle={'body2'} mt={4} color={'greyscale.grey3'}>
        กรุณากลับสู่หน้าแรกแล้วเข้าสู่บทเรียนอีกครั้ง
      </Text>
      <Box py={7} />
      <ButtonFilled height={'40px'} borderRadius={'20px'} py={0} onClick={handleBackToHome}>
        กลับหน้าแรก
      </ButtonFilled>
    </Flex>
  );
};
export default AppIncompletedContent;
